import { useMutation } from '@tanstack/react-query'

import { saveBlob } from './download'

/**
 * Downloads the table on screen as CSV, for either source. The file is fetched, so a refusal (no
 * `exports.create`, a range the API will not serve, a server error) is shown
 * here, in words, instead of being saved as a `.csv` holding an error body.
 */
export function CsvButton({
  fetchCsv,
  filename,
  errorMessage,
}: {
  fetchCsv: () => Promise<Blob>
  filename: string
  /** The screen's own wording for a refusal: GA4's and the first-party export's differ. */
  errorMessage: (error: unknown, fallback: string) => string
}) {
  const download = useMutation({ mutationFn: fetchCsv, onSuccess: (blob) => saveBlob(blob, filename) })
  return (
    <>
      <button type="button" className="ci-button" disabled={download.isPending} onClick={() => download.mutate()}>
        {download.isPending ? 'Preparing CSV…' : 'Download CSV'}
      </button>
      {download.isError ? (
        <p role="alert" className="tr-error">
          {errorMessage(download.error, 'The CSV could not be prepared just now. Try again in a moment.')}
        </p>
      ) : null}
    </>
  )
}
